// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-5fae96eb]::-webkit-outer-spin-button,\ninput[data-v-5fae96eb]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number][data-v-5fae96eb] {\n  -moz-appearance: textfield;\n}\n[data-v-5fae96eb] .b-form-btn-label-control.form-control > .form-control {\n  white-space: nowrap;\n  word-break: normal;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}", ""]);
// Exports
module.exports = exports;
